"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditLogDefinition = void 0;
const firestore_1 = require("comodel/firestore");
exports.auditLogDefinition = (0, firestore_1.defineCollection)({
    collectionName: "auditLog",
    idKey: "auditLogId",
    constraints: ["projectId"],
    queryDefs: {
        list: ({ projectId, createdAt, condition, }) => {
            const constraint = (() => {
                if (projectId)
                    return { projectId };
                return undefined;
            })();
            const filter = (() => {
                if (projectId)
                    return { "constraint.projectId": projectId, createdAt };
                return undefined;
            })();
            return {
                constraint,
                queryParams: {
                    filter,
                    orderBy: [["createdAt", "desc"]],
                },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
